const styles = theme => ({
    root: {
        display: 'flex'
    },
    formControl: {
        margin: theme.spacing(0)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`
    },
    buttons: {
        marginTop: theme.spacing(1),
        marginBottom: 0,
        paddingBottom: '0!important'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        color: '#fff'
    },
    questionPageFooterTextWrapper: {
        padding: theme.spacing(0, 0.25),
        '& p:last-child': {
            marginBottom: 0
        }
    },
    [theme.breakpoints.down(600)]: {
        buttons: {
            padding: '4px!important'
        },
        button: {
            padding: '4px 24px!important'
        }
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
        marginRight: -theme.spacing(1) * 0.5
    },
    radio: {
        minWidth: '110px'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        marginRight: theme.spacing(2),
        minWidth: '112px'
    },
    logoImg: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    },
    questionWrapper: {
        marginBottom: theme.spacing(2)
    },
    imageWrapper: {
        width: '100%',
        textAlign: 'center'
    },
    image: {
        maxWidth: '100%',
        height: 'auto'
    },
    dialog: {
        margin: '0 -24px!important'
    },
    questionContainer: {
        width: 'calc(100% + 16px)',
        margin: '-8px'
    },
    prelanderQuestion: {
        minHeight: 147
    },
    prelanderAnswerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(0, -1),
        flexDirection: 'column',
        textAlign: 'center'
    },
    prelanderAnswer: {
        margin: theme.spacing(0.375, 0.5),
        padding: theme.spacing(0.25, 1),
        background: theme.palette.primary.main,
        color: '#fff',
        borderRadius: 32,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.5, 0.5),
            fontSize: '1rem'
        }
    }
})

export { styles }
